import { BankCardSystem, PaymentMethodType } from '../../types';
import { formatCardNumber, isMethodIdCard, isMethodIdSbp } from '../../utils/common';
var normalizeCards = function (cards) {
    return (cards
        .sort(function (card1, card2) { return card2.last_paid_ts - card1.last_paid_ts || 0; })
        .map(function (rawCard) {
        var system = rawCard.system.toLowerCase();
        var partnerInfo = rawCard.partner_info;
        var card = {
            id: rawCard.id,
            type: PaymentMethodType.card,
            number: formatCardNumber(rawCard.number),
            system: BankCardSystem.unknown
        };
        switch (system) {
            case 'visa':
                card.system = BankCardSystem.visa;
                break;
            case 'mastercard':
                card.system = BankCardSystem.mastercard;
                break;
            case 'maestro':
                card.system = BankCardSystem.maestro;
                break;
            case 'mir':
                card.system = BankCardSystem.mir;
                break;
        }
        if (partnerInfo) {
            var yabankCardLabels = partnerInfo.yabank_card_labels;
            var isYabankCard = partnerInfo.is_yabank_card, isYabankCardOwner = partnerInfo.is_yabank_card_owner;
            if (isYabankCard &&
                isYabankCardOwner &&
                (!yabankCardLabels || yabankCardLabels.length === 0)) {
                yabankCardLabels = ['YANDEX_BANK_PLUS_CARD'];
            }
            card.partnerInfo = {
                isYabankCard: isYabankCard,
                isYabankCardOwner: isYabankCardOwner,
                yabankCardLabels: yabankCardLabels
            };
        }
        if (rawCard.card_bank) {
            card.issuer = rawCard.card_bank;
        }
        return card;
    }));
};
export var normalizeMethods = function (methods) {
    var cards = methods.filter(function (item) {
        return isMethodIdCard(item.id);
    });
    var sbpTokens = methods.filter(function (item) {
        return isMethodIdSbp(item.id);
    });
    return [].concat(normalizeCards(cards), sbpTokens);
};
